<template>
  <div class="timeline-player" :style="usedStyle">
    <div class="timeline-player__wrap" :style="wrapStyle">
      <keep-alive v-for="(frag, i) in fragments" :key="frag.id">
        <fragment-player
          v-if="i === activeFragmentIndex"
          :fragment="frag"
          :prevFragment="fragments[i - 1]"
          :local="i === activeFragmentIndex"
          :current="current - frag.start"
          :playing="playing"
        />
      </keep-alive>
      <stamp-player :local="true" :hideStamp="hideStamp" />
    </div>
    <effect-cover />
    <audio-player
      v-for="audio in allAudios"
      :key="audio.id"
      :effect="audio"
      :current="current"
      :playing="playing"
    />
  </div>
</template>
<script>
import FragmentPlayer from './FragmentPlayer';
import EffectCover from '../effectCover/EffectCover';
import StampPlayer from './StampPlayer';
import AudioPlayer from './AudioPlayer';
import { mapGetters, mapState } from 'vuex';

export default {
  components: {
    'fragment-player': FragmentPlayer,
    'effect-cover': EffectCover,
    'stamp-player': StampPlayer,
    'audio-player': AudioPlayer
  },
  computed: {
    ...mapGetters(['activeFragment']),
    ...mapState(['activeFragmentIndex']),
    current() {
      return this.$store.state.currentProgress;
    },
    fragments() {
      return this.$store.state.fragments;
    },
    playing() {
      return this.$store.state.playing;
    },
    usedStyle() {
      const height = 480 * this.$store.state.playerScale / 100;
      return {
        width: this.$store.state.screenRatio * height + 'px',
        height: height + 'px'
      };
    },
    wrapStyle() {
      return {
        transform: `scale(${this.$store.state.playerScale / 100})`,
        width: this.$store.state.screenRatio * 480 + 'px'
      };
    },
    hideStamp() {
      return this.$store.getters.activeFragment.hideStamp;
    },
    allAudios() {
      return [].concat.apply([], this.fragments.map(frag => frag.audios.map(id => {
        const ret = this.$store.state.audios[id];
        return {
          ...ret,
          start: ret.start + frag.start
        };
      })));
    }
  }
}
</script>
<style>
.timeline-player {
  /*width: 720px;*/
  height: 480px;
  background: #fff;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 0;
  display: inline-block;
  vertical-align: middle;
  margin: 32px 0;
  text-align: center;
  white-space: normal;
}

.timeline-player__wrap {
  position: absolute;
  height: 480px;
  top: 0;
  left: 0;
  transform-origin: left top;
}
</style>
